<template>
  <div class="tender-manage">
    <div class="tender-head">
      <div class="head-left">
        <h4 class="head-left-title">{{bidData.bidName}}</h4>
        <div class="head-left-bottom">
          <div class="text">
            <span class="text-left">招标编码</span>
            <span class="text-right">{{bidData.bidNo}}</span>
          </div>
          <div class="text">
            <span class="text-left">招标方式</span>
            <span class="text-right">{{bidData.bidTypeText}}</span>
          </div>
          <div class="text">
            <span class="text-left">招标状态</span>
            <span class="text-right">{{bidData.bidStatusText}}</span>
          </div>
        </div>
      </div>
      <div class="head-right">
        <div class="step">
          <div
            class="step-img"
            :class="processData==='tenderdocument'?'active':''"
            @click="handClick('tenderdocument')"
          >
              <svg v-if="processData==='tenderdocument'" class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_fa_s" />
            </svg>
            <svg v-else class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_fa" />
            </svg>
          </div>
          <p class="step-text">招标方案</p>
        </div>
        <span class="line"></span>
        <div class="step">
          <div
            class="step-img"
            :class="processData==='supplierbid'?'active':''"
            @click="handClick('supplierbid')"
          >
           <svg v-if="processData==='supplierbid'" class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_yb_s" />
            </svg>
            <svg v-else class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_yb" />
            </svg>
          </div>
          <p class="step-text">供应商应标管理</p>
        </div>
        <span class="line"></span>
        <div class="step" v-if="bidData.isShowTab">
          <div
            class="step-img"
            :class="processData==='graderesult'?'active':''"
            @click="handClick('graderesult')"
          >
            <svg v-if="processData==='graderesult'" class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_jg_s" />
            </svg>
               <svg v-else class="icon" aria-hidden="true">
              <use xlink:href="#iconzb-jg1" />
            </svg>
          </div>
          <p class="step-text">综合评分结果</p>
        </div>
        <span class="line" v-if="bidData.isShowTab"></span>
        <div class="step">
          <div
            class="step-img"
            :class="processData==='roundquote'?'active':''"
            @click="handClick('roundquote')"
          >
             <svg v-if="processData==='roundquote'" class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_bj_s" />
            </svg>
            <svg v-else class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_bj" />
            </svg>
          </div>
          <p class="step-text">轮次报价</p>
        </div>
        <span class="line"></span>
        <div class="step">
          <div
            class="step-img"
            :class="processData==='tenderresult'?'active':''"
            @click="handClick('tenderresult')"
          >
            <svg v-if="processData==='tenderresult'" class="icon" aria-hidden="true">
              <use xlink:href="#iconzb_jg_s" />
            </svg>
            <svg v-else class="icon" aria-hidden="true">
              <use xlink:href="#iconzb-jg1" />
            </svg>
          </div>
          <p class="step-text">招标结果</p>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import '@/styles/fonts/iconfont';
import { dictWithUrl } from '@/components/lots/api';
export default {
    data() {
        return {
            dictData: {}, // 数字字典
            bidData: {},
            bidNo: '',
            iflowId: this.$route.query.mbpmFlowId,
            processData: ''
        };
    },
    mounted() {
        // 数字字典转换
        dictWithUrl('SU_BID_TYPE,BID_STATUS').then(res => {
            this.dictData = res.data;
            this.init();
        });
    },
    methods: {
        handClick(name) {
            if (name === this.$route.name) {
                return false;
            }
            if (this.processData === 'tenderdocument' && !this.bidData.saveBtn) { // 当前在招标方案页面，且标书合同没有保存
                this.$confirm('当前合同还没保存，是否确认离去？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    if (name === 'tenderdocument') {
                        this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                    }
                    this.processData = name;
                    this.$router.push({
                        name: name,
                        query: { bidNo: this.$route.query.bidNo, mbpmFlowId: this.iflowId }
                    });
                }).catch(() => {});
            } else {
                if (name === 'tenderdocument') {
                    this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                }
                this.processData = name;
                this.$router.push({
                    name: name,
                    query: { bidNo: this.$route.query.bidNo, mbpmFlowId: this.iflowId }
                });
            }
        },
        async init() {
            this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
            this.processData = this.$route.name;
        },
        conversionData(obj) {
            if (obj.bidType) {
                obj.bidTypeText = this.dictData.SU_BID_TYPE[obj.bidType];
                obj.bidStatusText = this.dictData.BID_STATUS[obj.bidStatus];
                obj.bidStatus = obj.bidStatus;
            }
        }
    },
    computed: {
        loginState: function() {
            return this.$store.state.bidData;
        }
    },
    watch: {
        '$route.name': function(newVal, oldVal) {
            this.processData = newVal;
        },
        loginState(val) {
            this.bidData = val;
            this.conversionData(this.bidData);
        }
    }
};
</script>
<style lang="less">
.tender-manage {
  margin: 10px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 5px #f2f2f2;
  min-width: 1200px;
  box-sizing: border-box;
  padding: 16px;
  flex: 1 auto;
}
.tender-head {
  padding: 0 17px;
  display: flex;
  background-color: #f6f6f7;
  min-height: 85px;
// .head-left{min-width:320px;}
  .head-left-title {
    margin: 0;
    margin-top: 20px;
    font-size: 16px;
     max-width:470px;
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
  }
  .head-left-bottom {
    margin-top: 10px;
    margin-bottom: 20px;
    display: flex;
  }
  .text {
    display: flex;
    align-items: center;
  }
  .text-left {
    margin-right: 5px;
    font-size: 12px;
    color: #888888;
    line-height: 12px;
  }
  .text-right {
    margin-top: 0;
    margin-right: 15px;
    font-size: 12px;
    color: #333333;
    line-height: 12px;
  }
  .head-right {
    display: flex;
    margin-left: 50px;
  }
  .step {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
  .line {
    margin-top: 26px;
    width: 80px;
    height: 5px;
    background-color: #ececec;
  }
  .step-img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #ececec;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .step-text {
    margin: 0;
    margin-top: 10px;
    font-size: 12px;
    color: #333333;
    line-height: 12px;
  }
  .active {
    background-color: #00bcbf;
  }
}
</style>